var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDankort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 177,
    viewBox: "0 0 312 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1416_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.71 9.47998C59.1297 9.47998 23.6797 44.92 23.6797 88.5C23.6797 132.08 59.1297 167.53 102.71 167.53H209.14C252.71 167.53 288.16 132.08 288.16 88.5C288.16 44.92 252.71 9.47998 209.14 9.47998H102.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.14 169.13H102.71C58.2503 169.13 22.0703 132.96 22.0703 88.5001C22.0703 44.0401 58.2503 7.87012 102.71 7.87012H209.14C253.6 7.87012 289.77 44.0401 289.77 88.5001C289.77 132.96 253.6 169.13 209.14 169.13ZM102.71 9.48012C59.1303 9.48012 23.6803 44.9201 23.6803 88.5001C23.6803 132.08 59.1303 167.53 102.71 167.53H209.14C252.71 167.53 288.16 132.08 288.16 88.5001C288.16 44.9201 252.71 9.48012 209.14 9.48012H102.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.75 83.67L263.14 125.76C270.47 115.17 274.78 102.33 274.78 88.49C274.78 73.89 269.98 60.39 261.89 49.48L227.75 83.67Z",
    fill: "#DC0D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.461 45.9304C153.891 45.9304 173.801 52.6503 175.851 74.9203L203.671 45.9203H259.061C247.011 31.8203 229.111 22.8604 209.151 22.8604H102.711C82.741 22.8604 64.841 31.8203 52.791 45.9203H127.461V45.9304Z",
    fill: "#DC0D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9107 74L74.4707 99.95H112.551C123.811 99.95 127.211 95.29 129.731 86.32C132.221 77.45 125.961 74 118.271 74H83.9107Z",
    fill: "#DC0D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.9 129.3L174.48 92.1201C169.04 117.47 151.23 129.29 117.85 129.29H51.3301C63.3601 144.41 81.9201 154.13 102.71 154.13H209.14C229.92 154.13 248.47 144.42 260.51 129.3H203.9Z",
    fill: "#DC0D19"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1416_526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 311.81,
    height: 177,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDankort);
export default __webpack_public_path__ + "static/media/dankort.b6b7107b0118c82fd413382e35c6b9cf.svg";
export { ForwardRef as ReactComponent };